import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MonthlyPerformance from "./monthlyPerformance/monthlyPerformance";
import Returns from "./Returns/returns";
import PortfolioGrowth from "./portfolioGrowth/PortfolioGrowth";
import Yearly from "./yearlyPerformance/yearly";
import BarchartHolder from "./Returns/section1/barchartHolder";
import HomeChart from "../../../../helper/homechart.helper";
import WithCard from "../../../common/withCard";
import DownloadPdfButton from "../../../common/buttons/downloadPdfButton";
import PDFHelper from "../../../parts/pdfmaker/pdf.helper";
import {
  StyleSheet,
  Image as IMG,
  View,
  Document,
  Page,
  Text,
  pdf,
} from "@react-pdf/renderer";
import { pdfStyles } from "../Component page/pdf.styles";
import PdfHeader from "../../../parts/pdfmaker/common/pdfHeader";
import PdfTable from "../../../parts/pdfmaker/common/pdfTable";
import pdfLegend from "../../../parts/pdfmaker/common/pdfLegend";
import PerformanceHelper from "./performance.helper";
import "./performance.scss";

class Performance extends Component {
  state = {
    HistMetricsLive: [],
    port_info: {
      port_min_dt: null,
      port_max_dt: null,
      bm_min_dt: null,
      bm_max_dt: null,
      fund_name: null,
      bm_name: null,
    },
    // pdf_return_table_heading: [],
    // pdf_return_table_data: [],
    pdf_legends: [],
    colors: ["#81efde", "#4c6ead", "#8775a7"],
    return_VS_volatility: [],
    return_vs_volatality_table_heading: [
      { title: "" },
      { title: "Return" },
      { title: "Volatility" },
    ],
    portfolio_growth_table_heading: [],
    portfolio_growth_table_data: [],
    return_vs_vol_pdf_table: [],
    getRiskStatistics: [],
    portfolio_return_table_heading: [],
    portfolio_return_table_data: [],
    calendar_yearly_data: [],
    calendar_yearly_pdf_heading: [],
    calendar_yearly_pdf_data: [],
    annualized_yearly_data: [],
    annualized_yearly_pdf_heading: [],
    annualized_yearly_pdf_data: [],
    getBacktest: {},
  };
  async componentDidMount() {
    const {
      getBacktest,
      getRiskStatistics,
      clientBacktestData,
      getPerfHistMetrics,
      model_name,
      typeName,
      original_riskStatistics,
      clientHistmetrics,
      display_orig_portfolio,
    } = this.props;
    let homechartportinfo = HomeChart.getPortfolioInfo(
      getBacktest.getPortfolioVami,
      getBacktest.getBenchmarkVami
    );
    this.setState({
      port_info: {
        ...this.state.port_info,
        port_min_dt: homechartportinfo.port_min_dt || 0,
        port_max_dt: homechartportinfo.port_max_dt || 0,
        bm_min_dt: homechartportinfo.bm_min_dt || 0,
        bm_max_dt: homechartportinfo.bm_max_dt || 0,
        fund_name: homechartportinfo.fund_name || 0,
        bm_name: homechartportinfo.bm_name || 0,
      },
      getBacktest,
    });

    if (getPerfHistMetrics) {
      this.setState({
        HistMetricsLive: getPerfHistMetrics,
      });
    }

    // return vs volatality data
    let return_VS_volatility = PerformanceHelper.return_volatility_modifier({
      getRiskStatistics,
      original_riskStatistics,
      getBacktest,
      clientBacktestData,
    });

    this.setState({
      return_VS_volatility: return_VS_volatility["final_data"],
      return_vs_vol_pdf_table: return_VS_volatility["pdfTableData"],
    });

    if (getRiskStatistics && getRiskStatistics.length > 0) {
      let data = PerformanceHelper.portfolio_return_table({
        getRiskStatistics,
        original_riskStatistics,
        model_name,
        typeName,
      });

      this.setState({
        getRiskStatistics,
        portfolio_return_table_heading: data["portfolio_return_table_heading"],
        portfolio_return_table_data: data["portfolio_return_table_data"],
      });
    }

    // performance calendar yearly backtest data
    if (getPerfHistMetrics && getPerfHistMetrics.length) {
      let calendar_yearly_data = PerformanceHelper.calendar_year_backtest_performance(
        { getPerfHistMetrics, clientHistmetrics }
      );

      this.setState({
        calendar_yearly_data: calendar_yearly_data.data,
        calendar_yearly_pdf_heading:
          calendar_yearly_data.calendar_yearly_pdf_heading,
        calendar_yearly_pdf_data: calendar_yearly_data.calendar_yearly_pdf_data,
      });
    }

    // performance annualize match
    if (getPerfHistMetrics && getPerfHistMetrics.length) {
      let annuaized_yearly_data = PerformanceHelper.annualized_modifyData({
        data: getPerfHistMetrics,
        client_data: clientHistmetrics,
        display_orig_portfolio,
      });

      this.setState({
        annuaized_yearly_data: annuaized_yearly_data.data,
        annualized_yearly_pdf_heading:
          annuaized_yearly_data.annualized_yearly_pdf_heading,
        annualized_yearly_pdf_data:
          annuaized_yearly_data.annualized_yearly_pdf_data,
      });
    }
    // setting pdf legends
    let pdf_legends = [];
    if (display_orig_portfolio) {
      pdf_legends.push("IQCIO Model +", "Benchmark *", "Original Portfolio");
    } else {
      pdf_legends.push("Portfolio", "Benchmark");
    }
    this.setState({
      pdf_legends,
    });

    // portfolio table growth table data modify
    if (getPerfHistMetrics && getPerfHistMetrics.length > 0) {
      let newBenchmarkName = display_orig_portfolio ? "Original Portfolio" : "";
      let portfolio_growth_table = PerformanceHelper.portfolio_growth_table({
        HistMetricsLive: getPerfHistMetrics,
        compare_histmetrics: clientHistmetrics,
        newBenchmarkName,
        display_orig_portfolio,
        model_name,
      });

      if (
        portfolio_growth_table &&
        portfolio_growth_table["portfolio_growth_table_data"] &&
        portfolio_growth_table["portfolio_growth_table_heading"]
      ) {
        this.setState({
          portfolio_growth_table_data:
            portfolio_growth_table.portfolio_growth_table_data,
          portfolio_growth_table_heading:
            portfolio_growth_table.portfolio_growth_table_heading,
        });
      }
    }
  }
  async componentWillReceiveProps(nextProps) {
    const {
      getBacktest,
      getRiskStatistics,
      getPerfHistMetrics,
      clientBacktestData,
      original_riskStatistics,
      model_name,
      typeName,
      clientHistmetrics,
      display_orig_portfolio,
    } = nextProps;

    let homechartportinfo = HomeChart.getPortfolioInfo(
      getBacktest.getPortfolioVami,
      getBacktest.getBenchmarkVami
    );
    this.setState({
      port_info: {
        ...this.state.port_info,
        port_min_dt: homechartportinfo.port_min_dt || 0,
        port_max_dt: homechartportinfo.port_max_dt || 0,
        bm_min_dt: homechartportinfo.bm_min_dt || 0,
        bm_max_dt: homechartportinfo.bm_max_dt || 0,
        fund_name: homechartportinfo.fund_name || 0,
        bm_name: homechartportinfo.bm_name || 0,
      },
      getBacktest,
    });

    if (getPerfHistMetrics) {
      this.setState({
        HistMetricsLive: getPerfHistMetrics,
      });
    }

    // return vs volatality data
    if (getBacktest) {
      let return_VS_volatility = PerformanceHelper.return_volatility_modifier({
        getRiskStatistics,
        original_riskStatistics,
        getBacktest,
        clientBacktestData,
      });
      if (
        return_VS_volatility &&
        return_VS_volatility["final_data"] &&
        return_VS_volatility["pdfTableData"]
      ) {
        this.setState({
          return_VS_volatility: return_VS_volatility["final_data"],
          return_vs_vol_pdf_table: return_VS_volatility["pdfTableData"],
        });
      }
    }
    if (
      JSON.stringify(this.props.getRiskStatistics) !=
      JSON.stringify(getRiskStatistics)
    ) {
      let data = PerformanceHelper.portfolio_return_table({
        getRiskStatistics,
        original_riskStatistics,
        model_name,
        typeName,
      });

      this.setState({
        getRiskStatistics,
        portfolio_return_table_heading: data["portfolio_return_table_heading"],
        portfolio_return_table_data: data["portfolio_return_table_data"],
      });
    }

    // calendar yearly backtest data
    if (getPerfHistMetrics && getPerfHistMetrics.length) {
      let calendar_yearly_data = PerformanceHelper.calendar_year_backtest_performance(
        { getPerfHistMetrics, clientHistmetrics }
      );

      this.setState({
        calendar_yearly_data: calendar_yearly_data.data,
        calendar_yearly_pdf_heading:
          calendar_yearly_data.calendar_yearly_pdf_heading,
        calendar_yearly_pdf_data: calendar_yearly_data.calendar_yearly_pdf_data,
      });
    }

    // performance annualize match
    if (getPerfHistMetrics && getPerfHistMetrics.length) {
      let annuaized_yearly_data = PerformanceHelper.annualized_modifyData({
        data: getPerfHistMetrics,
        client_data: clientHistmetrics,
        display_orig_portfolio,
      });

      this.setState({
        annuaized_yearly_data: annuaized_yearly_data.data,
        annualized_yearly_pdf_heading:
          annuaized_yearly_data.annualized_yearly_pdf_heading,
        annualized_yearly_pdf_data:
          annuaized_yearly_data.annualized_yearly_pdf_data,
      });
    }
    // setting pdf legends
    if (this.props.display_orig_portfolio !== display_orig_portfolio) {
      let pdf_legends = [];
      if (display_orig_portfolio) {
        pdf_legends.push("IQCIO Model +", "Benchmark *", "Original Portfolio");
      } else {
        pdf_legends.push("Portfolio", "Benchmark");
      }

      this.setState({
        pdf_legends,
      });
    }

    // portfolio table growth table data modify
    if (getPerfHistMetrics && getPerfHistMetrics.length > 0) {
      let newBenchmarkName = display_orig_portfolio ? "Original Portfolio" : "";
      let portfolio_growth_table = PerformanceHelper.portfolio_growth_table({
        HistMetricsLive: getPerfHistMetrics,
        compare_histmetrics: clientHistmetrics,
        newBenchmarkName,
        display_orig_portfolio,
        model_name,
      });
      if (
        portfolio_growth_table &&
        portfolio_growth_table["portfolio_growth_table_data"] &&
        portfolio_growth_table["portfolio_growth_table_heading"]
      ) {
        this.setState({
          portfolio_growth_table_data:
            portfolio_growth_table.portfolio_growth_table_data,
          portfolio_growth_table_heading:
            portfolio_growth_table.portfolio_growth_table_heading,
        });
      }
    }
  }

  // pdf creation
  exportToPDF = () => {
    const { getBacktest, type } = this.props;
    const {
      return_vs_volatality_table_heading,
      return_vs_vol_pdf_table,
      portfolio_return_table_heading,
      portfolio_return_table_data,
      calendar_yearly_pdf_heading,
      calendar_yearly_pdf_data,
      annualized_yearly_pdf_heading,
      annualized_yearly_pdf_data,
      pdf_legends,
      colors,
      portfolio_growth_table_heading,
      portfolio_growth_table_data,
    } = this.state;
    let heading = "";
    if (getBacktest) {
      heading = this.props.heading
        ? this.props.heading
        : getBacktest["getPortfolioMetrics"][0]["scenario_name"];
    }

    Promise.allSettled([
      PDFHelper.svgToPng("line_chart_02"),
      PDFHelper.svgToPng("circle_arc_chart"),
      PDFHelper.svgToPng("return_vs_vol"),
      PDFHelper.svgToPng("backtestBarChart5"),
      PDFHelper.svgToPng("backtestBarChart4"),
      PDFHelper.svgToPng("brush_bar01"),
      PDFHelper.svgToPng("yearly_barChart_returns"),
    ]).then((values) => {
      const styles = StyleSheet.create({
        ...pdfStyles,
      });

      let text_style = {
        color: "#223279",
        textAlign: "center",
        paddingTop: 5,
        paddingBottom: 5,
      };

      const MyDoc = () => (
        <Document>
          <Page size="A4" wrap style={styles.pb}>
            <PdfHeader mainHeading={heading + " - " + "PERFORMANCE"} />
            <View style={styles.paddingHorizontal}>
              <View style={{ marginTop: 20 }}>
                <View style={text_style}>
                  <Text>PORTFOLIO GROWTH</Text>
                </View>
                <View>
                  {pdfLegend({ colors: colors, data_list: pdf_legends })}
                </View>
                <IMG source={values[0].value}></IMG>
                <View>
                  <PdfTable
                    data={portfolio_growth_table_data}
                    heading={portfolio_growth_table_heading}
                    Width={100 / portfolio_growth_table_heading.length + "%"}
                  />
                </View>
              </View>
              <View style={{ marginTop: 30 }}>
                <View style={text_style}>
                  <Text>TOTAL GROWTH</Text>
                </View>
                <View
                  style={{
                    // display: "flex",
                    // justifyContent: "center",
                    marginLeft: 80,
                  }}
                >
                  <IMG source={values[1].value}></IMG>
                </View>
              </View>
            </View>
          </Page>
          <Page size="A4" wrap style={{ paddingVertical: 20 }}>
            <View style={styles.paddingHorizontal}>
              <View style={{ marginTop: 20 }}>
                <View style={text_style}>
                  <Text>PORTFOLIO RETURNS</Text>
                </View>
                {portfolio_return_table_data && (
                  <View>
                    <PdfTable
                      heading={portfolio_return_table_heading}
                      data={portfolio_return_table_data}
                      Width={
                        portfolio_return_table_heading.length == 4
                          ? "25%"
                          : "33.33%"
                      }
                    />
                  </View>
                )}
              </View>
              <View style={{ marginTop: 40 }}>
                <View style={text_style}>
                  <Text>RETURN VS.VOLATALITY</Text>
                </View>
                <View>
                  {pdfLegend({ colors: colors, data_list: pdf_legends })}
                </View>
                <IMG source={values[2].value}></IMG>

                <View>
                  <PdfTable
                    heading={return_vs_volatality_table_heading}
                    data={return_vs_vol_pdf_table}
                    Width={"33.33%"}
                  />
                </View>
              </View>
            </View>
          </Page>
          {type == "BACKTEST" && (
            <Page size="A4" wrap style={{ paddingVertical: 20 }}>
              <View style={styles.paddingHorizontal}>
                <View style={{ marginTop: 20 }}>
                  <View style={text_style}>
                    <Text>ANNUALIZED BACK-TESTED PERFORMANCE</Text>
                  </View>
                  <View>
                    {pdfLegend({ colors: colors, data_list: pdf_legends })}
                  </View>
                  <IMG source={values[3].value}></IMG>
                  <View>
                    <PdfTable
                      data={annualized_yearly_pdf_data}
                      heading={annualized_yearly_pdf_heading}
                      Width={100 / annualized_yearly_pdf_heading.length + "%"}
                    />
                  </View>
                </View>
                <View style={{ marginTop: 40 }}>
                  <View style={text_style}>
                    <Text>CALENDAR YEAR BACK-TESTED PERFORMANCE</Text>
                  </View>
                  <View>
                    {pdfLegend({ colors: colors, data_list: pdf_legends })}
                  </View>
                  <IMG source={values[4].value}></IMG>
                  <View>
                    <PdfTable
                      data={calendar_yearly_pdf_data}
                      heading={calendar_yearly_pdf_heading}
                      Width={100 / calendar_yearly_pdf_heading.length + "%"}
                    />
                  </View>
                </View>
              </View>
            </Page>
          )}
          {values[5].value ? (
            <Page size="A4" wrap style={{ paddingVertical: 20 }}>
              <View style={styles.paddingHorizontal}>
                <View style={{ marginTop: 20 }}>
                  <View style={text_style}>
                    <Text>MONTHLY PERFORMANCE</Text>
                  </View>
                  <View>
                    {pdfLegend({ colors: colors, data_list: pdf_legends })}
                  </View>
                  <IMG source={values[5].value}></IMG>
                </View>
                <View style={{ marginTop: 40 }}>
                  {values[6].value ? (
                    <View>
                      <View style={text_style}>
                        <Text>RETURNS DISTRIBUTION</Text>
                      </View>
                      <View>
                        {pdfLegend({ colors: colors, data_list: pdf_legends })}
                      </View>
                      <IMG source={values[6].value}></IMG>
                    </View>
                  ) : null}
                </View>
              </View>
            </Page>
          ) : null}
        </Document>
      );
      pdf(<MyDoc />)
        .toBlob()
        .then((blob) => {
          const link = document.createElement("a");
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = "performance.pdf";
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
        });
    });
  };
  render() {
    const {
      HistMetricsLive,
      return_VS_volatility,
      getRiskStatistics,
      portfolio_return_table_heading,
      portfolio_return_table_data,
      calendar_yearly_data,
      annuaized_yearly_data,
      portfolio_growth_table_heading,
      portfolio_growth_table_data,
      getBacktest,
    } = this.state;
    const {
      getPerfHistMetrics,
      analyze_compare,
      benchmark_name,
      clientBacktestData,
      model_name,
      display_orig_portfolio,
      clientHistmetrics,
      original_riskStatistics,
      typeName,
      type,
    } = this.props;
    return (
      <div className="performance">
        <WithCard>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 performance_download_btn">
              <DownloadPdfButton handler={this.exportToPDF} />
            </div>
          </div>
        </WithCard>
        <WithCard>
          {HistMetricsLive.length > 0 ? (
            <PortfolioGrowth
              {...this.props}
              {...this.state}
              portfolio_growth_table_heading={portfolio_growth_table_heading}
              portfolio_growth_table_data={portfolio_growth_table_data}
              HistMetricsLive={HistMetricsLive}
              analyze_compare={analyze_compare}
              benchmark_name={benchmark_name}
              clientBacktestData={clientBacktestData}
              model_name={model_name}
              display_orig_portfolio={display_orig_portfolio}
              compare_histmetrics={clientHistmetrics}
            />
          ) : null}
        </WithCard>

        <Returns
          portfolio_return_table_heading={portfolio_return_table_heading}
          portfolio_return_table_data={portfolio_return_table_data}
          getRiskStatistics={getRiskStatistics}
          return_VS_volatility={return_VS_volatility}
          getBacktest={getBacktest}
          HistMetricsLive={HistMetricsLive}
          analyze_compare={analyze_compare}
          benchmark_name={benchmark_name}
          clientBacktestData={clientBacktestData}
          model_name={model_name}
          display_orig_portfolio={display_orig_portfolio}
          compare_histmetrics={clientHistmetrics}
          original_riskStatistics={original_riskStatistics}
        />
        {annuaized_yearly_data &&
        annuaized_yearly_data.length > 0 &&
        calendar_yearly_data &&
        annuaized_yearly_data.length > 0 ? (
          <Yearly
            annuaized_yearly_data={annuaized_yearly_data}
            type={type}
            calendar_yearly_data={calendar_yearly_data}
            benchmark_name={benchmark_name}
            display_orig_portfolio={display_orig_portfolio}
            analyze_compare={analyze_compare}
            model_name={model_name}
            typeName={typeName}
          />
        ) : null}
        {HistMetricsLive.length > 0 ? (
          <MonthlyPerformance
            {...this.props}
            HistMetricsLive={HistMetricsLive}
          />
        ) : null}
        {getBacktest &&
        Object.keys(getBacktest).length > 0 &&
        getBacktest.getMetricsForRange ? (
          <BarchartHolder
            typeName={typeName}
            getMetricsForRange={getBacktest.getMetricsForRange}
          />
        ) : null}
      </div>
    );
  }
}

Performance.propTypes = {
  type: PropTypes.string,
  typeName: PropTypes.string,
  foo: PropTypes.number,
  scenario_id: PropTypes.number,
  getBacktest: PropTypes.object,
};
export default connect(
  ({
    create: {
      steps: {
        risk: { benchmark_name, display_orig_portfolio },
        universeLite: {
          analyze_compare: { clientBacktestData },
          model_name,
          analyze_compare,
        },
      },
    },
  }) => ({
    benchmark_name,
    clientBacktestData,
    model_name,
    display_orig_portfolio,
    analyze_compare,
    clientHistmetrics: analyze_compare.getPerfHistmetrics,
    original_riskStatistics: analyze_compare.riskStatistics,
  }),
  null
)(Performance);



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/performance.jsx